import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportEndOfDayReport } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import Pagination from 'screens/components/basic/Pagination';
import { getEndOfDayReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import AutomationDrawer from '../ReportAutomation/AutomationDrawer';
import { getAutomationButtons } from "../ReportAutomation/AutomationButtons";
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import { Button } from '@mui/material';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class EndOfDayReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            isOpenDrawer: false
        };
        this.showBody = this.showBody.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date, `EndOfDayReportBeginDate`);
        this.props.formInput(date, `EndOfDayReportEndDate`);
    }

    getReport = () => {
        const branch = this.props.endOfDayReportLocations ? this.props.endOfDayReportLocations.join(",") : this.props.loggedBranch;
        const beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        const endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        this.props.getEndOfDayReport({ branch, beginDate, endDate });
    }

    downloadReport = () => {
        console.log("adads")
        const branch = this.props.endOfDayReportLocations ? this.props.endOfDayReportLocations.join(",") : this.props.loggedBranch;
        const beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        const currentDate = this.props.beginDate ? moment(this.props.beginDate).format('YYYYMMDD') : moment().add('day').format('YYYYMMDD');
        const branchName = (this.props.endOfDayReportLocations != undefined && this.props.endOfDayReportLocations.length > 1) ? "Multi_Store_EOD" : this.props.branchOptions.find(option => option.value === String(branch)).text;
        const endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            if (moment(endDate).diff(beginDate, 'days') <= 31) {
                this.props.getCsvReport(`reports/excel/endOfDay?branch=${branch}&beginDate=${beginDate}&endDate=${endDate}`, `${branchName}_EOD-${currentDate}`);
            } else {
                this.props.showError(LOOKUP.report.common.dateRangeLimitError);
            }
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryLevelWarehouse`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            if (moment(this.props.endDate).diff(this.props.beginDate, 'days') <= 31) {
                this.filter();
                this.setState({ showBody: true });
            } else {
                this.props.showError(LOOKUP.report.common.dateRangeLimitError);
            }
        }
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    toggleDrawer = (open) => {
        if (typeof open === 'boolean') {
            this.setState({ isOpenDrawer: open });
        } else {
            this.setState((prevState) => ({ isOpenDrawer: !prevState.isOpenDrawer }));
        }
    }

    automationModel = () => {
        const { AutomationBranchIds, AutomationEmail, loggedBranch } = this.props;
        const model = {
            Email: AutomationEmail,
            BranchId: loggedBranch,
            ReportBranchIds: AutomationBranchIds || [],
            ReportId: 11,
            Ids: AutomationBranchIds || [],
            APIUrl: "ReportEmailAutomation/Create",
            CompanyCode: localStorage.getItem('TECHPOS_CompanyCode') || ``
        };
        return model;
    }

    render() {
        const totalRow = this.props.endOfDay ? this.props.endOfDay.length > 0 ? this.props.inventorySnapShot[0].totalrow : 0 : 0;
        const drawerContent = getAutomationButtons("EndOfDayReport")({ defaultBranch: this.props.defaultBranch, branchOptions: this.props.branchOptions });
        return (
            <Grid headerContent={reportEndOfDayReport}>
                <PageHeaderWithButton
                    title={LOOKUP.report.endOfDay.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-end-of-day-report" />}
                    description={LOOKUP.report.endOfDay.description}
                >
                <a href="/admin/cashregister">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#5F4BB3",
                            color: "white",
                            '&:hover': {
                                backgroundColor: "#4a3a8a",
                            },
                        }}
                    >
                        Cash Register Page
                    </Button>
                </a>
                </PageHeaderWithButton>
                <Header
                    defaultBranch={this.props.defaultBranch}
                    branchOptions={this.props.branchOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    toggleDrawer={this.toggleDrawer}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body endOfDay={this.props.endOfDay}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate} />

                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
                <AutomationDrawer name={"End of Day Report"} open={this.state.isOpenDrawer} toggleDrawer={this.toggleDrawer} drawerContent={drawerContent} reportModel={this.automationModel} reportId={11} headerMessage={"Note: You can schedule the EOD report to be emailed daily. If scheduled, reports are emailed daily at 4:00 AM"} reportName={"EndOfDay"} />
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let defaultBranch = [];
    defaultBranch.push({ text: state.common.branchId.toString(), value: state.common.branchId.toString() });
    return {
        branchOptions: branchOptions,
        selectedBranch: state.form.EndOfDayReportBranchOption,
        loggedBranch: state.common.branchId,
        beginDate: state.form.EndOfDayReportBeginDate,
        endDate: state.form.EndOfDayReportEndDate,
        endOfDay: state.reports.endOfDay,
        defaultBranch: defaultBranch,
        endOfDayReportLocations: state.form.EndOfDayReportLocations,
        AutomationBranchIds: state.form.EndOfDayReportAutomationLocations || ["1"],
        AutomationEmail: state.form.EndOfDayReportAutomationEmail
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getEndOfDayReport: (model) => dispatch(getEndOfDayReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(EndOfDayReport));
